<div #wrapper class="external-meals-wrapper">
    <app-modal-header [text]="'external_meals' | localise" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <ng-container>
        <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
            <ng-template #itemTemplate let-item>
                <a [innerHTML]="item[keyword]"></a>
            </ng-template>

            <ng-template #notFoundTemplate let-notFound>
                <div [innerHTML]="notFound"></div>
            </ng-template>

            <table class="external-table">
                <tr *ngFor="let externalMeal of externalMeals; let i = index">
                    <td class="text-align-center" style="padding: 0;">
                        <button
                                (click)="removeExternalMeal(i)"
                                class="btn btn-sm btn-danger"><i class="ti-close"></i></button>
                    </td>
                    <td style="min-width: 125px;">
                        <ng-autocomplete
                                [placeHolder]="('meal_placeholder' | localise) + ' ...'"
                                [data]="data"
                                [searchKeyword]="keyword"
                                (selected)='onExternalMealSelected($event, i)'
                                (inputChanged)='onExternalMealTitleChanged($event, i)'
                                (inputCleared)='onExternalMealCleared(i)'
                                [itemTemplate]="itemTemplate"
                                [notFoundTemplate]="notFoundTemplate"
                                [initialValue]="externalMeal"
                        >
                        </ng-autocomplete>
                    </td>
                    <td
                            *ngIf="externalMeal.type == 'product'"
                            (click)="openWeightQtyModal(externalMeal, i)"
                            class="weight">
                        <span class="external-meal-macro">
                            <i class="fa fa-pencil"></i>
                        </span>

                        <button
                                class="btn btn-sm btn-block font-weight-medium btn-warning">
                            <i class="ti-pencil mr-2"></i><br/>
                            {{ 'kol_br' | localise }}
                        </button>
                    </td>
                    <td
                            [ngClass]="externalMeal.calories > 0 ? 'with-macro' : ''"
                            (click)="prompt('calories', i)">
                        <span class="external-meal-macro-title">
                        {{ 'calories' | localise }}:
                        </span>
                        <span class="external-meal-macro">
                            {{ externalMeal.calories }} kcal
                            <i class="fa fa-pencil"></i>
                        </span>

                        <button
                                class="btn btn-sm btn-block font-weight-medium btn-primary">
                            <i class="ti-plus mr-2"></i>
                            {{ 'calories' | localise }}
                        </button>
                    </td>
                    <td
                            [ngClass]="externalMeal.protein > 0 ? 'with-macro' : ''"
                            (click)="prompt('protein', i)">
                        <span class="external-meal-macro-title">
                         {{ 'protein' | localise }}:
                        </span>
                        <span class="external-meal-macro">
                            {{ externalMeal.protein }} {{ 'abbreviation_gram' | localise }}
                            <i class="fa fa-pencil"></i>
                        </span>

                        <button
                                class="btn btn-sm btn-block font-weight-medium btn-primary">
                            <i class="ti-plus mr-2"></i>
                            {{ 'protein' | localise }}
                        </button>
                    </td>
                    <td
                            [ngClass]="externalMeal.carbs > 0 ? 'with-macro' : ''"
                            (click)="prompt('carbs', i)">
                        <span class="external-meal-macro-title">
                        {{ 'carb' | localise }}:
                        </span>
                        <span class="external-meal-macro">
                            {{ externalMeal.carbs }} {{ 'abbreviation_gram' | localise }}
                            <i class="fa fa-pencil"></i>
                        </span>

                        <button

                                class="btn btn-sm btn-block font-weight-medium btn-primary">
                            <i class="ti-plus mr-2"></i>
                            {{ 'carb' | localise }}
                        </button>
                    </td>
                    <td
                            [ngClass]="externalMeal.fat > 0 ? 'with-macro' : ''"
                            (click)="prompt('fat', i)">
                        <span class="external-meal-macro-title">
                        {{ 'fats' | localise }}:
                        </span>
                        <span class="external-meal-macro">
                            {{ externalMeal.fat }} {{ 'abbreviation_gram' | localise }}
                            <i class="fa fa-pencil"></i>
                        </span>

                        <button
                                class="btn btn-sm btn-block font-weight-medium btn-primary">
                            <i class="ti-plus mr-2"></i>
                            {{ 'fats' | localise }}
                        </button>
                    </td>

                    <td
                            [ngClass]="externalMeal.diary_meal ? 'with-macro' : ''"
                            (click)="openDiaryMealModal(externalMeal, i)">
                        <span class="external-meal-macro-title">
                        Хранене:
                        </span>
                        <span class="external-meal-macro">
                            <ng-container *ngIf="externalMeal.diary_meal">
                                {{ externalMeal.diary_meal.title }}
                            </ng-container>

                            <i class="fa fa-pencil"></i>
                        </span>

                        <button
                                class="btn btn-sm btn-block font-weight-medium btn-primary">
                            <i class="ti-plus mr-2"></i>
                            {{ 'hranene' | localise }}
                        </button>
                    </td>
                </tr>
            </table>

            <div class="text-align-center" style="margin-top: 15px;position: fixed;left: 47%;">
                <button (click)="addNewRow()"
                        class="add-new-external-meal btn btn-inverse-primary btn-rounded btn-icon">
                    <div class="responsive-flex-wrapper">
                        <i class="ti-plus"></i>
                    </div>
                </button>
            </div>
        </div>

        <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
            <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
            <button type="button" class="btn btn-success" (click)="onSave()">{{ 'save' | localise }}</button>
        </div>
    </ng-container>
</div>
